import { useContext } from 'react';

import pageDataContext from '@glass/shared/modules/pageData/PageDataContext';

const usePageData = () => useContext(pageDataContext) || {};

export default usePageData;
